/**
 * Global Fetch Interceptor
 * 
 * Monkey-patches the global window.fetch to capture 401 Unauthorized responses.
 * When a 401 is detected, it dispatches a custom 'auth-401' event which the 
 * KeycloakContext listens for to forcefully end the session and clear state.
 */

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  let [resource, config] = args;

  const url = typeof resource === 'string' ? resource : (resource instanceof Request ? resource.url : '');
  
  if (url.startsWith('/api') || url.includes('/api/')) {
    const isTestMode = localStorage.getItem('identifid-mode') === 'test';
    if (isTestMode) {
      config = config || {};
      config.headers = {
        ...config.headers,
        'Identifid-Mode': 'test'
      };
    }
  }

  const response = await originalFetch.apply(this, [resource, config] as any);

  if (response.status === 401) {
    // Check if it's a relative URL or points to our API
    if (url.startsWith('/api') || url.includes('/api/')) {
      window.dispatchEvent(new CustomEvent('auth-401'));
    }
  }

  return response;
};
